export const promoCodeParam = 'promoCode';
